module.exports = __webpack_public_path__ + "img/computer_first_guide.78faf706.png";